module.exports = __webpack_public_path__ + "static/images/yq-bg.101ae19.png";